import Default from '@pages/profile-dylan'

export default {
  path: 'profile/dylan',
  name: 'profile-dylan',
  components: {
    default: Default,
  },
}